export function getPrompt(value) {
  return value === 'responsiblePersonContactDetails'
    ? 'What is the phone number of the person responsible for the patient?'
    : "What is the patient's phone number?"
}
